import { Button, IconButton } from "@mui/material";
import type { MenuItem } from "@ssf/components";
import { CascadingMenu } from "@ssf/components";
import { DotsVertical, MenuDown } from "mdi-material-ui";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export const Menu = ({ children }: { children?: ReactNode }) => {
  const { t } = useTranslation("Menu");
  const menu = t("navigation", { returnObjects: true }) as MenuItem[];

  return (
    <>
      {menu.map(
        (item) =>
          item.title && (
            <Button
              key={item.title}
              {...(item.link
                ? {
                    component: Link,
                    to: item.link || "",
                  }
                : {
                    component: CascadingMenu,
                    menu: { ...item, component: "button" },
                  })}
              color="inherit"
              size="small"
              sx={({ breakpoints }) => ({
                display: "none",
                [breakpoints.up("md")]: {
                  display: "flex",
                },
              })}
            >
              {item.title}
              {item.subMenu && <MenuDown />}
            </Button>
          ),
      )}
      {children}
      <CascadingMenu menu={{ subMenu: menu }}>
        {(onClick) => (
          <IconButton
            onClick={onClick}
            sx={({ breakpoints }) => ({
              [breakpoints.up("md")]: {
                display: "none",
              },
            })}
          >
            <DotsVertical />
          </IconButton>
        )}
      </CascadingMenu>
    </>
  );
};
